import React, { useState, useRef, useEffect } from 'react';
import { HiUserCircle } from 'react-icons/hi';
import { IoLogOut } from 'react-icons/io5';
import { BsFillPersonFill } from 'react-icons/bs';
import PopUp from '../PopUp/PopUp';
import { useAuth } from "../../contexts/auth";

const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const dropdownRef = useRef(null);
  const { user } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);


  const cancelLogout = () => {
    setOpenDeleteModal(false);
    setIsOpen(false);
  }

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';
    setOpenDeleteModal(false);
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // 


  return (
    <>
    <div className="relative" ref={dropdownRef}> 
      <button
        onClick={toggleDropdown}
        className="flex items-center text-white focus:outline-none"
      >
        <HiUserCircle color='white' size='1.5em' className='mr-0 md:mr-2' />
        <p className="hidden md:block text-[white]">
          {user && user.name && user.name.split(' ')[0]}
        </p>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-[150px] bg-white bg-clip-content rounded-lg shadow-lg z-[100px] bg-[#ffebc7] hover:bg-[#ffe4b3] hover:shadow-sm">
          <button
            onClick={() => window.location.href = '/auth/inventory'}
            className="flex flex-row w-[100%] items-center px-4 py-2 text-gray-800 text-sm hover:bg-[#cec57c85] hover:border-[#ffebc7]"
          >
            <BsFillPersonFill size='1.2em' className='mr-2' />
            My Inventory
          </button>
          <button
            onClick={() => setOpenDeleteModal(true)}
            className="flex flex-row w-[100%] items-center px-4 py-2 text-gray-800 text-sm  hover:bg-[#cec57c85] hover:rounded-b-lg hover:border-[#ffebc7]"
          >
            <IoLogOut size='1.2em' className='mr-2' />
            Logout
          </button>
        </div>
      )}
    </div>
    <PopUp
      title="Logout"
      message="Are you sure you want to logout?"
      open={openDeleteModal}
      setOpen={setOpenDeleteModal}
      yesText="Logout"
      noText="Cancel"
      yesColor="error"
      noColor="primary"
      handleYes={handleLogout}
      handleNo={cancelLogout}
    />
    </>
  );
};

export default ProfileDropdown;
